var _a;
import { ERROR_CODE, KERNEL_NAME, VIDEO_TYPE } from '../enums';
import { urlTool } from '../util';
import kernelAvailable from './kernel-available';
import { createMetadata } from './metadata';
/** URL注入参数key名 */
var UrlParamKey;
(function (UrlParamKey) {
    UrlParamKey["forceKernel"] = "__forceKernel";
})(UrlParamKey || (UrlParamKey = {}));
/**
 * 按优先级顺序排列的内核名称数组，从高到低依次判断
 * ORIGIN作为兜底内核使用，原则上来说没有匹配上的，都尝试使用origin方式播放
 * WASM内核很特殊且使用有限制，所以不在列表里，如果需要使用只能外部指定
 */
export var KERNEL_NAME_BY_PRIORITY = [
    KERNEL_NAME.HLS_JS,
    KERNEL_NAME.FLV_JS,
    KERNEL_NAME.WEBRTC,
    KERNEL_NAME.ORIGIN,
];
/**
 * 从视频格式到内核名称的映射，这里是全量内核列表
 */
export var VIDEO_TYPE_2_AVAILABEL_MAP = (_a = {},
    _a[KERNEL_NAME.HLS_JS] = kernelAvailable.isHlsjsAvailable,
    _a[KERNEL_NAME.FLV_JS] = kernelAvailable.isFlvjsAvailable,
    _a[KERNEL_NAME.WEBRTC] = kernelAvailable.isWebrtcplayerAvailable,
    _a[KERNEL_NAME.DEMUX_2_FMP4] = kernelAvailable.isDemux2fmp4Available,
    _a[KERNEL_NAME.ORIGIN] = function () { return true; },
    _a[KERNEL_NAME.WASM] = kernelAvailable.isWasmplayerAvailble,
    _a[KERNEL_NAME.ELECTRON] = kernelAvailable.isElectronPlayerAailble,
    _a);
/*
 * 从视频格式到内核名称的映射
 */
export var VIDEO_TYPE_2_KERNEL_NAME_MAP = {
    flv: KERNEL_NAME.FLV_JS,
    hls: KERNEL_NAME.HLS_JS,
    webrtc: KERNEL_NAME.WEBRTC,
};
/**
 * 用于根据当前播放配置信息选择合适的播放内核名称
 */
var KernelSelector = /** @class */ (function () {
    function KernelSelector() {
    }
    KernelSelector.getSelector = function () {
        if (!this.selector) {
            this.selector = new KernelSelector();
        }
        return this.selector;
    };
    /**
    * 根据播放配置自动选择选择播放内核。也可以强行指定播放内核名称，但仍然需要通过一些校验才会决定是否使用。
    * @param urlConfig 播放配置信息
    * @param forceKernelName 强制使用某种内核
    * @param kernelPriority 自定义内核选择时的优先级
    * @returns 被选择的内核名称
    */
    KernelSelector.prototype.selectByURLConfig = function (urlConfig, forceKernelName, kernelPriority) {
        var metadata = createMetadata(urlConfig);
        // 优先级1：如果外部指定使用内核，一般用于debug或者引用方指定，所以优先级最高
        return this.selectKernelWithAssign(metadata, forceKernelName)
            // 优先级2：按优先级列表选择能播放对应格式的内核
            || this.selectKernelInPresetMap(metadata, kernelPriority);
    };
    /**
     * 如果外部指定使用内核，无论如何都立即返回该内核
     */
    KernelSelector.prototype.selectKernelWithAssign = function (metadata, forceKernelName) {
        var _a;
        var kernelName = forceKernelName;
        // 如果有通过url参数指定，无论如何都立即返回该内核，优先级比forceKernelName更高
        var kernelNameFromUrlParam = urlTool.getUrlParamByKey(location.href, UrlParamKey.forceKernel);
        // 指定内核在预设列表里才可以用
        if (kernelNameFromUrlParam && Object.keys(VIDEO_TYPE_2_AVAILABEL_MAP).includes(kernelNameFromUrlParam)) {
            kernelName = kernelNameFromUrlParam;
        }
        // 外部指定了内核名称，并且是因为播放地址无法确定后缀而指定的，直接返回（否则通不过`VIDEO_TYPE_2_AVAILABEL_MAP`的校验）
        if (forceKernelName && metadata.videoType === VIDEO_TYPE.OTHER) {
            return forceKernelName;
        }
        // forceKernel和URL都没有强制指定参数，直接返回走自动设定
        if (!kernelName) {
            return null;
        }
        // 如果指定的内核可以播放该视频
        if ((_a = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName]) === null || _a === void 0 ? void 0 : _a.call(VIDEO_TYPE_2_AVAILABEL_MAP, metadata)) {
            return kernelName;
        }
        // 强制指定内核不能播放，返回错误
        var suggestKernelName = this.suggestKernelNameByMetadata(metadata, KERNEL_NAME_BY_PRIORITY);
        var message = "".concat(kernelName !== KERNEL_NAME.ORIGIN ? "".concat(kernelName, "\u5185\u6838") : '', "\u65E0\u6CD5\u64AD\u653E\u5F53\u524D\u683C\u5F0F")
            + "".concat(suggestKernelName && suggestKernelName !== KERNEL_NAME.ORIGIN ? "\uFF0C\u8BF7\u5C1D\u8BD5\u4F7F\u7528".concat(suggestKernelName, "\u5185\u6838\u64AD\u653E") : '');
        return {
            code: ERROR_CODE.MISSING_KERNEL,
            message: message,
        };
    };
    /**
     * 根据视频信息选择可用的内核
     * @param metadata 视频信息
     * @param kernelPriority 外部有要求调整制定的内核顺序
     * @returns 内核名称
     */
    KernelSelector.prototype.selectKernelInPresetMap = function (metadata, kernelPriority) {
        var kernelNames;
        // 如果有外部干预内核列表
        if (kernelPriority) {
            kernelNames = kernelPriority;
            // 把用户自定义列表中没有包含的内核也补上
            for (var i = 0; i < KERNEL_NAME_BY_PRIORITY.length; i++) {
                if (kernelPriority.indexOf(KERNEL_NAME_BY_PRIORITY[i]) === -1) {
                    kernelNames.push(KERNEL_NAME_BY_PRIORITY[i]);
                }
            }
        }
        else {
            kernelNames = KERNEL_NAME_BY_PRIORITY;
        }
        // 遍历当前所有的播放内核，看看哪个支持当前的视频类型
        return this.suggestKernelNameByMetadata(metadata, kernelNames);
    };
    /**
    * 遍历当前所有的播放内核，看看哪个内核支持当前的视频类型
    * @param metadata 视频信息
    * @param kernelNames 内核列表
    */
    KernelSelector.prototype.suggestKernelNameByMetadata = function (metadata, kernelNames) {
        var _a;
        if (!metadata) {
            return null;
        }
        // 遍历当前所有的播放内核，看看哪个支持当前的视频类型
        for (var i = 0; i < kernelNames.length; i++) {
            var kernelName = kernelNames[i];
            if ((_a = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName]) === null || _a === void 0 ? void 0 : _a.call(VIDEO_TYPE_2_AVAILABEL_MAP, metadata)) {
                return kernelName;
            }
        }
        return null;
    };
    /**
     * 根据kernelName和urlConfig验证该内核是否支持
     * @param kernelName 目标内核名称
     * @param urlConfig 视频信息
     * @returns 是否支持
     */
    KernelSelector.prototype.isKernelSupportByUrlConfig = function (kernelName, urlConfig) {
        var isKernelAvailable = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName];
        if (!isKernelAvailable) {
            return false;
        }
        var metadata = createMetadata(urlConfig);
        return isKernelAvailable(metadata);
    };
    return KernelSelector;
}());
export { KernelSelector };
